// @ts-nocheck
import React, { useCallback } from 'react';
import * as PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import Checkbox from '../checkbox/Checkbox';

const FormCheckbox = (props: {
  id: any;
  name: any;
  required: any;
  disabled: any;
  validate: any;
  children: any;
}) => {
  const { id, name, required, disabled, validate, children } = props;

  const { t } = useTranslation();

  const { errors, register } = useFormContext();

  const generateValidators = useCallback(() => {
    const validators = { required: '' };
    if (required) {
      validators.required = t('v2.global.label_helperText_mandatoryField');
    }
    if (validate) {
      validators.validate = validate;
    }
    return validators;
  }, [required, validate, t]);

  return (
    <Checkbox
      id={id}
      name={name}
      disabled={disabled}
      error={!!errors[name]}
      ref={register(generateValidators())}
    >
      <Hidden smDown>
        <Box component={Typography} variant="body1">
          {children}
        </Box>
      </Hidden>
      <Hidden mdUp>
        <Box component={Typography} variant="body1">
          {children}
        </Box>
      </Hidden>
      {errors[name] && (
        <Typography variant="body2" color="error">
          {errors[name].message}
        </Typography>
      )}
    </Checkbox>
  );
};

FormCheckbox.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  validate: PropTypes.func,
  children: PropTypes.node,
};

FormCheckbox.defaultProps = {
  required: false,
  disabled: false,
  validate: null,
  children: null,
};

export default FormCheckbox;
